var getters = {
  userInfo: function userInfo(state) {
    return state.user.userInfo;
  },
  // lang: state => state.app.lang,
  logo: function logo(state) {
    if (state.app.logo) {
      return state.app.logo;
    }
    return require('@/assets/img/logo.png');
  },
  name: function name(state) {
    if (state.app.name) {
      return state.app.name;
    }
    return '长涛网络小贷ERP系统';
  },
  activeIndex: function activeIndex(state) {
    return state.app.sidebar.activeIndex;
  },
  navActiveIndex: function navActiveIndex(state) {
    return state.app.navbar.activeIndex;
  },
  // 权限
  allAuth: function allAuth(state) {
    return state.user.allAuth;
  },
  navList: function navList(state) {
    return state.app.navlist;
  },
  menulist: function menulist(state) {
    return state.app.menulist;
  }
};

export default getters;